import styled from '@emotion/styled'
import type { PaymentOrderV2 } from '@mynt/backoffice-api-spec/payment'
import JSONDetailPanel from '../../components/JSONDetailPanel'
import Spacings from '../../figma/tokens/Spacings'
import FigmaBox from '../../mynt-components/components/FigmaBox'
import { formatAmount } from '../../tiger/libs/Common'

const OutboundPaymentDetails = ({ paymentOrder }: { paymentOrder: PaymentOrderV2 }) => (
  <DetailWrapper fullWidth direction="row" gap={Spacings.max}>
    <FigmaBox>
      <SectionTitle>General</SectionTitle>
      <InfoRow label="ID" value={paymentOrder.id} />
      <InfoRow label="End-to-End ID" value={paymentOrder.endToEndId} />
      <InfoRow label="State" value={paymentOrder.stateLabel} />
      <InfoRow label="State Reason" value={paymentOrder.stateReason ?? ''} />
      <InfoRow label="Scheduled Date" value={paymentOrder.scheduledPaymentDate} />
      <InfoRow label="Created" value={paymentOrder.createdAt} />
      <InfoRow label="Modified" value={paymentOrder.modifiedAt} />
      <SectionTitle>Recipient</SectionTitle>
      <InfoRow label="Name" value={paymentOrder.destinationDetails?.recipient?.recipientName ?? ''} />
      <InfoRow label="Address" value={paymentOrder.destinationDetails?.recipient?.address?.address1 ?? ''} />
      <InfoRow label="City" value={paymentOrder.destinationDetails?.recipient?.address?.city ?? ''} />
      <InfoRow label="Area Code" value={paymentOrder.destinationDetails?.recipient?.address?.areaCode ?? ''} />
      <InfoRow label="Country" value={paymentOrder.destinationDetails?.recipient?.address?.country ?? ''} />
    </FigmaBox>
    <FigmaBox>
      <SectionTitle>Source</SectionTitle>
      <InfoRow label="Type" value={paymentOrder.source?.type ?? ''} />
      <InfoRow label="Ref" value={paymentOrder.source?.ref ?? ''} />
      <SectionTitle>Destination</SectionTitle>
      <InfoRow label="Type" value={paymentOrder.destination?.type ?? ''} />
      <InfoRow label="Ref" value={paymentOrder.destination?.ref ?? ''} />
      <SectionTitle>Payment Details</SectionTitle>
      <InfoRow label="Amount" value={paymentOrder.destinationDetails?.amount ? formatAmount(paymentOrder.destinationDetails.amount) : ''} />
      <InfoRow label="Instruction ID" value={paymentOrder.destinationDetails?.instructionId ?? ''} />
      <InfoRow label="Sender IBAN" value={paymentOrder.destinationDetails?.senderIban ?? ''} />
      <InfoRow label="Sender BIC" value={paymentOrder.destinationDetails?.senderBic ?? ''} />
    </FigmaBox>
    <FigmaBox>
      <SectionTitle>Raw JSON</SectionTitle>
      <JSONDetailPanel src={paymentOrder} collapsed />
    </FigmaBox>
  </DetailWrapper>
)

const InfoRow = ({ label, value }: { label: string; value: string }) => (
  <Row direction="row" gap={Spacings.tiny}>
    <Label>{label}:</Label>
    <span>{value || '-'}</span>
  </Row>
)

const DetailWrapper = styled(FigmaBox)`
  padding-bottom: ${Spacings.small};
  border-bottom: 1px solid #e0e0e0;
`

const SectionTitle = styled.h4`
  margin: ${Spacings.small} 0 ${Spacings.tiny} 0;

  &:first-of-type {
    margin-top: 0;
  }
`

const Label = styled.span`
  font-weight: 600;
  min-width: 130px;
`

const Row = styled(FigmaBox)`
  margin-bottom: ${Spacings.minimum};
`

export default OutboundPaymentDetails
